module.exports = ".glyphicon {\n  font-family: inherit; }\n\n.glyphicon:before {\n  font-family: 'Glyphicons Halflings'; }\n\n.download-button {\n  width: 50%; }\n\n.download-button.btn-group > .btn {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/export/configurations/export-configurations.component.scss
// module id = ./src/app/admin/export/configurations/export-configurations.component.scss
// module chunks = main